import { render, staticRenderFns } from "./FeedbackInfo.vue?vue&type=template&id=adb382aa"
import script from "./FeedbackInfo.vue?vue&type=script&lang=js"
export * from "./FeedbackInfo.vue?vue&type=script&lang=js"
import style0 from "./FeedbackInfo.vue?vue&type=style&index=0&id=adb382aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports